export const testimonials = [
  {
    context: "Amber was critical of creating a user-friendly planning tool capable of guiding users through an otherwise complicated delineation process.",
    name: "David M.",
    role: "Subject Matter Expert"
  },
  {
    context: "Amber conducted thorough user research, derived insights, and implemented them in a way that enhanced the overall user journey, leading to a significant increase in user engagement and satisfaction.",
    name: "Anthony H.",
    role: "Product Owner"
  },
  {
    context: "Amber is a gifted designer with a remarkable command of visual elements. She skillfully deploys color, typography, and layout to produce designs that are not only beautiful but also captivating and effective.",
    name: "Preston I.",
    role: "Technology Specialist"
  },
  {
    context: "What's truly remarkable is how she showcased her work in a train demo to over 400 audiences. That's an unprecedented feat in our setting. This strongly demonstrates that the quality of her work has exceeded expectations.",
    name: "Yatong W.",
    role: "UX Designer & Researcher"
  },
  {
    context: "Amber's expertise extends beyond aesthetics; she possesses a notable talent for effectively adapting her work to align with diverse branding guidelines, ensuring design is perfectly suited to its brand identity.",
    name: "Kevin M.",
    role: "Director of Marketing & Communication"
  },
  {
    context: "Amber has been an invaluable member of my team for the last 2-plus years, providing expert interactive prototypes of some very complex systems. The designs she produces is clear, smooth, and beautiful.",
    name: "Will C.",
    role: "Sr. Business Analyst"
  },
  {
    context: "Amber possesses a wealth of skills and qualities that makes her an exceptional choice for UX/UI Design. She excels in applying UX principles to identify and address usability issues effectively.",
    name: "Eugenia A.",
    role: "Lead UX/UI Designer"
  },
  {
    context: "She has a quick mind that can stretch in both analytical and creative directions. She turns things around quickly, even when they are complex or ambiguous.",
    name: "Jimmy Z.",
    role: "Sr. Program Manager"
  },
  {
    context: "Amber is a quick study who consistently exceeds expectations. She demonstrates a strong sense of ownership over her work and naturally takes on a leadership role, ensuring every project is a success.",
    name: "Rosa F.",
    role: "Regional Director"
  },
  {
    context: "Amber is so dependable and proactive, SFI and the Intrepid team are blessed by her contributions.",
    name: "Michael L.",
    role: "Technical Project Manager"
  }
];